<template>
  <div>
    <div class="col-md-12 row">
      <div class="md6 row pl-4 pt-5">
        <label style="text-align: left" class="col-md-12 pl-0"
          >Please enter analyst note</label
        >
        <b-row>
          <b-col cols="11">
            <b-form-textarea
              rows="8"
              id="textarea-rows"
              max-rows="10"
              v-model="analystRemarks"
              placeholder="Note by Analyst"
            >
            </b-form-textarea>
          </b-col>
          <b-col cols="12" align-self="start" class="pt-2">
            <b-button variant="info" type="submit" @click="addorupdateNote()">
              <span v-if="editId">Edit Note</span>
              <span v-else>Add Note</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
      <div align="center" class="flex md6 row pl-4 class1">
        <label style="text-align: left" class="col-md-12 pl-0"
          >Please update the verification status</label
        >
        <b-card class="col-md-6">
          <h6>Reliable</h6>
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="exampleCheck1"
              v-model="crimeVerification.reliable"
              @change="checkboxChange('reliable', crimeVerification.reliable)"
            />
            <label class="form-check-label" for="exampleCheck1">Yes</label>
          </div>
        </b-card>

        <b-card class="col-md-6">
          <h6>Accurate</h6>
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="exampleCheck1"
              v-model="crimeVerification.accurate"
              @change="checkboxChange('accurate', crimeVerification.accurate)"
            />
            <label class="form-check-label" for="exampleCheck1">Yes</label>
          </div>
        </b-card>
        <b-card class="col-md-6">
          <h6>Time-Bound</h6>
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="exampleCheck1"
              v-model="crimeVerification.timeBound"
              @change="checkboxChange('timeBound', crimeVerification.timeBound)"
            />
            <label class="form-check-label" for="exampleCheck1">Yes</label>
          </div>
        </b-card>
        <b-card class="col-md-6">
          <h6>Actionable</h6>
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="exampleCheck1"
              v-model="crimeVerification.actionable"
              @change="
                checkboxChange('actionable', crimeVerification.actionable)
              "
            />
            <label class="form-check-label" for="exampleCheck1">Yes</label>
          </div>
        </b-card>
      </div>
    </div>
    <b-row class="pt-4" v-if="analystNotes.length > 0">
      <b-col cols="12">
        <b-card>
          <b-row style="font-size: 14px; font-weight: bold">
            <b-col cols="3"> Date & Time </b-col>
            <b-col cols="5"> Note </b-col>
            <b-col cols="2"> Analyzed by </b-col>
            <b-col cols="2" class="text-center"> Actions </b-col>
          </b-row>
        </b-card>
        <b-card v-for="item in analystNotes" :key="item._id">
          <b-row>
            <b-col cols="3">
              {{ item.create_date }}
            </b-col>
            <b-col cols="5">
              {{ item.note }}
            </b-col>
            <b-col cols="2">
              <span v-if="item.adminId.usertype==0">Admin</span>
              <span v-else>{{item.adminId.name}}</span>
            </b-col>
            <b-col cols="1">
              <b-button
                variant="outline-info"
                class="py-1 px-2"
                type="submit"
                @click="editItem(item)"
                >Edit</b-button
              >
            </b-col>
            <b-col cols="1">
              <b-button
                variant="outline-danger"
                class="py-1 px-2"
                type="submit"
                @click.prevent="confirmRemoveNote(item._id)"
                >Delete</b-button
              >
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  props: ['crimeData'],
  data () {
    return {
      analystRemarks: null,
      crimeVerification: {
        reliable: false,
        accurate: false,
        timeBound: false,
        actionable: false,
      },
      priority: null,
      analystRemarks: null,
      analystNotes: [],
      editId: null,
      msg: null,
    }
  },
  beforeMount () {
    this.getAnalystNotes()
  },
  mounted () {
    var vm = this
    Object.keys(vm.crimeData.verificationStatus).forEach(function (key) {
      if (vm.crimeData.verificationStatus[key] == 'yes') {
        vm.crimeVerification[key] = true
      } else if (vm.crimeData.verificationStatus[key] == 'no') {
        vm.crimeVerification[key] = false
      }
    })
  },
  methods: {
    editItem (item, type) {
      this.analystRemarks = item.note
      this.editId = item._id
    },
    checkboxChange (type, value) {
      var data = {}
      if (value == true) value = 'yes'
      else value = 'no'
      data['id'] = this.crimeData._id
      if (type == 'accurate') data['accurate'] = value
      if (type == 'actionable') data['actionable'] = value
      if (type == 'timeBound') data['timeBound'] = value
      if (type == 'reliable') data['reliable'] = value
      axios({
        method: 'POST',
        url: '/crimereports/change/verificationStatus',
        headers: {
          token: localStorage.getItem('token'),
        },
        data: data,
      })
        .then((response) => {
          if (response.data.status) {
            this.$emit('stepper', {
              type: 'verification',
              response: response.data,
            })
          } else {
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    confirmRemoveNote (id) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to Remove this note.', {
          title: 'Please Confirm',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          cancelVariant: 'primary',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.removeNote(id)
          }
        })
        .catch((err) => {
          // An error occurred
        })
    },
    removeNote (id) {
      axios({
        method: 'POST',
        url: '/note/delete/' + id,
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.getAnalystNotes()
            this.msg = response.data.msg
            this.$bvToast.toast(this.msg, {
              // title: "update Status",
              autoHideDelay: 3000,
              variant: 'success',
            })
          } else {
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    addorupdateNote () {
      var data = {}
      var url
      data['crimeReportId'] = this.crimeData._id
      if (this.editId) {
        url = '/note/edit/' + this.editId
      } else {
        url = '/note/add'
      }
      data['note'] = this.analystRemarks
      axios({
        method: 'POST',
        url: url,
        headers: {
          token: localStorage.getItem('token'),
        },
        data: data,
      })
        .then((response) => {
          if (response.data.status) {
            this.getAnalystNotes()
            this.analystRemarks = null
            this.editId = null
          } else {
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getAnalystNotes () {
      var data = {}
      data['crimeReportId'] = this.crimeData._id

      axios({
        method: 'POST',
        url: '/notes/list',
        headers: {
          token: localStorage.getItem('token'),
        },
        data: data,
      })
        .then((response) => {
          if (response.data.status) {
            this.analystNotes = response.data.data
            for (var i = 0; i < this.analystNotes.length; i++) {
              var dt = new Date(this.analystNotes[i].create_date)
              dt = dt.toString()
              dt = dt.slice(4, 15) + ' , ' + this.formatTime(dt.slice(16, 21))
              this.analystNotes[i].create_date = dt
            }
          } else {
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },

    formatTime (item) {
      if (!item) return
      var hours = Number(item.split(':')[0])
      var minutes = Number(item.split(':')[1])
      var ampm = hours >= 12 ? 'PM' : 'AM'
      hours = hours % 12
      hours = hours || 12
      minutes = minutes < 10 ? '0' + minutes : minutes
      var strTime = hours + ':' + minutes + ' ' + ampm
      return strTime
    },
  },
}
</script>
<style>
.card {
    display: flex!important;
    border: 1px solid rgba(0, 0, 0, 0.125)!important;
    border-radius: 0.25rem!important;
}
</style>
